/**
 * Device configuration for Division 26 reusable components.
 */

import { formatDateUS } from './shared/dateUtils';

export const DEVICE_CATEGORIES = {
  'Lighting Devices': ['Light Fixture', 'Emergency Light', 'Exit Sign'],
  'Power Devices': ['Receptacle', 'GFCI Receptacle', 'USB Receptacle', 'Floor Box'],
  'Control Devices': ['Switch', 'Dimmer', 'Occupancy Sensor', 'Lighting Control Panel'],
  'Special Devices': ['Disconnect Switch', 'Electric Heater', 'Hand Dryer', 'EV Charger'],
  'Other': ['Other'],
};

export const DEVICE_TYPE_TO_CATEGORY = Object.entries(DEVICE_CATEGORIES).reduce((acc, [cat, types]) => {
  types.forEach(t => { acc[t] = cat; });
  return acc;
}, {});

export const ALL_DEVICE_TYPES = Object.values(DEVICE_CATEGORIES).flat();
export const ALL_CATEGORIES = Object.keys(DEVICE_CATEGORIES);

export const deviceListConfig = {
  moduleName: 'Device',
  testIdPrefix: 'elec-device',
  apiBase: '/electrical-devices',
  columns: [
    { key: 'deviceTag', label: 'Tag', cellClass: 'font-medium text-slate-900' },
    { key: 'category', label: 'Category', cellClass: 'text-slate-600' },
    { key: 'deviceType', label: 'Device Type', cellClass: 'text-slate-700' },
    { key: 'manufacturer', label: 'Manufacturer', cellClass: 'text-slate-700' },
    { key: 'model', label: 'Model', cellClass: 'text-slate-700' },
    {
      key: 'installDate',
      label: 'Install Date',
      render: (item) => formatDateUS(item.installDate),
    },
  ],
};

export const deviceFormConfig = {
  moduleName: 'Device',
  testIdPrefix: 'elec-device',
  fields: [
    { key: 'deviceTag', label: 'Tag', type: 'text', required: true, placeholder: 'e.g. LF-101' },
    { key: 'deviceType', label: 'Device Type', type: 'grouped_select', required: true, groups: DEVICE_CATEGORIES },
    { key: 'manufacturer', label: 'Manufacturer', type: 'text', required: true, placeholder: 'Enter manufacturer' },
    { key: 'model', label: 'Model', type: 'text', required: true, placeholder: 'Enter model' },
    { key: 'voltage', label: 'Voltage', type: 'numeric_unit', required: false, placeholder: 'e.g. 120', unitLabel: 'V' },
    { key: 'installDate', label: 'Install Date', type: 'date', required: false },
    { key: 'wattage', label: 'Wattage', type: 'numeric', required: false, placeholder: 'e.g. 48' },
    { key: 'color', label: 'Color', type: 'text', required: false, placeholder: 'e.g. White' },
    { key: 'notes', label: 'Notes', type: 'textarea', required: false, fullWidth: true, placeholder: 'Additional notes...' },
  ],
};

export const deviceReviewConfig = {
  moduleName: 'Device',
  testIdPrefix: 'elec-device',
  apiBase: '/electrical-devices',
  fields: [
    { key: 'deviceTag', label: 'Tag', type: 'text' },
    { key: 'category', label: 'Category', type: 'text' },
    { key: 'deviceType', label: 'Device Type', type: 'text' },
    { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
    { key: 'model', label: 'Model', type: 'text' },
    { key: 'voltageDisplay', label: 'Voltage', type: 'text' },
    { key: 'wattage', label: 'Wattage', type: 'text' },
    { key: 'installDate', label: 'Install Date', type: 'date' },
    { key: 'color', label: 'Color', type: 'text' },
    { key: 'notes', label: 'Notes', type: 'text', fullWidth: true },
  ],
};
